/**
 * SETUP PROPOSALS (EXPERT-NETWORKS.md §7c, E7 L3) — the experts prepared a platform step for this room (attach an
 * existing tested connection, or retire a one-time credential that has served its purpose); a person with the room's
 * run roles approves (the platform does it now) or rejects. Nothing changes until someone approves. Additive section.
 */
import React, { useState } from 'react';

const btn = 'px-2.5 py-1 text-xs font-medium rounded-md transition-colors';
const VERB = { 'pin-connection': 'Attach connection', 'retire-connection': 'Retire connection' };

export default function RoomLiaisonActions({ value, onDecide }) {
  const v = value || {};
  const [busy, setBusy] = useState('');
  const [err, setErr] = useState('');
  const decide = async (proposalId, action) => {
    if (!onDecide) return;
    setBusy(proposalId);
    setErr('');
    try {
      await onDecide({ action, proposalId });
    } catch (e) {
      setErr((e && e.message) || "Couldn't do that.");
    } finally {
      setBusy('');
    }
  };
  return (
    <div className="space-y-2 text-[12px]" data-testid="room-liaison-actions">
      <p className="text-[11px] text-gray-500">
        Steps the experts prepared for this room. Nothing changes until someone approves.
      </p>
      {(v.proposals || []).map((p) => (
        <div key={p.proposalId} className="rounded-md border border-amber-200 bg-amber-50/60 px-2 py-1.5"
          data-testid={`liaison-proposal-${p.proposalId}`}>
          <p className="text-[11px] text-amber-900">
            <span className="font-medium">{VERB[p.action] || p.action}</span>
            {p.capability ? <span className="text-gray-700"> · {p.capability}</span> : null}
            <span className="font-mono text-gray-700"> · {p.connectionId}</span>
          </p>
          {p.why ? <p className="mt-0.5 text-[11px] text-gray-600">{p.why}</p> : null}
          {v.canDecide ? (
            <div className="mt-1 flex gap-2">
              <button type="button" disabled={!!busy} className={`${btn} bg-amber-600 text-white hover:bg-amber-700`}
                data-testid={`liaison-approve-${p.proposalId}`} onClick={() => decide(p.proposalId, 'approve')}>Approve</button>
              <button type="button" disabled={!!busy} className={`${btn} text-amber-800 hover:bg-amber-100`}
                data-testid={`liaison-reject-${p.proposalId}`} onClick={() => decide(p.proposalId, 'reject')}>Reject</button>
            </div>
          ) : null}
        </div>
      ))}
      {err ? <p className="text-[11px] text-rose-600" data-testid="liaison-error">{err}</p> : null}
    </div>
  );
}
